import get from 'lodash.get';

const getCustomTextColors = (state) =>
  get(state, 'ws.site.meta.customization.customTextColors', []);

export default getCustomTextColors;
